// extracted by mini-css-extract-plugin
export default {"wrapper":"laIJS32JHO07q3caaKu2","boolean":"YQAFTrptTzh4wbdKDtYt","number":"FIaTCuRSam4LrK7cVrNg","float":"wpUb1V8SCEEigL3Matxn","date":"EtlV1JsIlHRiU3atvhtQ"};